import React, { memo, ReactNode, useCallback } from 'react';
import classNames from 'classnames';

import {
  AcAccordion,
  AcAccordionClampContent,
  AcAccordionContent,
  AcAccordionHeader,
  AcAccordionItem
} from '@ac/mobile-components/dist/components/accordion';
import { AcBox } from '@ac/mobile-components/dist/components/box';
import { AcDivider } from '@ac/mobile-components/dist/components/divider';
import { AcFlex } from '@ac/mobile-components/dist/components/flex';
import { AcIcon } from '@ac/mobile-components/dist/components/icon';
import { AcText } from '@ac/mobile-components/dist/components/text';
import {
  Icon,
  IconSize,
  JustifyContent
} from '@ac/mobile-components/dist/enums';
import { Styleable } from '@ac/mobile-components/dist/interfaces/componentProps';

import './SheetsSummaryAccordion.css';

export interface SheetsSummaryAccordionProps extends Styleable {
  title: string;
  renderSubtitle?: ReactNode;
  renderContent?: ReactNode;
  renderClampContent?: ReactNode;
  expandDisabled?: boolean;
  onExpandedChange?: (isExpanded: boolean) => void;
  icon: Icon;
}

export const SheetsSummaryAccordion: React.FC<SheetsSummaryAccordionProps> = (
  props: SheetsSummaryAccordionProps
) => {
  //NOTE:  sheets-summary-accordion2 fixes styles priority
  const classes = classNames(
    'sheets-summary-accordion',
    'sheets-summary-accordion2',
    props.className
  );
  const expandedChange = useCallback(
    (expandedList: string[]) => {
      if (props.onExpandedChange) {
        props.onExpandedChange(expandedList.length > 0);
      }
    },
    [props.onExpandedChange]
  );

  return (
    <AcBox className={classes}>
      <AcFlex
        justifyContent={JustifyContent.center}
        className="sheets-summary-accordion-icon"
      >
        <AcIcon
          icon={props.icon}
          size={IconSize.Giant}
          className="ac-spacing-top-md ac-spacing-bottom-md"
        />
      </AcFlex>
      <AcAccordion
        className="sheets-summary-accordion-info"
        onChange={expandedChange}
      >
        <AcAccordionItem id="1" disabled={props.expandDisabled}>
          <AcAccordionHeader testSelector="sheets-summary-accordion-header">
            <AcText testSelector="sheets-summary-accordion-title">
              {props.title}
            </AcText>
          </AcAccordionHeader>

          {props.renderSubtitle && <div>{props.renderSubtitle}</div>}

          {props.renderClampContent && (
            <AcAccordionClampContent minVisibleLines={2}>
              {props.renderClampContent}
            </AcAccordionClampContent>
          )}

          {props.renderContent && (
            <AcAccordionContent>
              <AcDivider className="sheets-summary-title-content-divider" />
              {props.renderContent}
            </AcAccordionContent>
          )}
        </AcAccordionItem>
      </AcAccordion>
    </AcBox>
  );
};

export default memo(SheetsSummaryAccordion);



// WEBPACK FOOTER //
// ./src/components/Attendant/SheetSummary/body/SheetSummaryAccordion/SheetsSummaryAccordion.tsx